import { render, staticRenderFns } from "./PersonalDeliveryInfo.vue?vue&type=template&id=cbbc64e2&"
import script from "./PersonalDeliveryInfo.vue?vue&type=script&lang=js&"
export * from "./PersonalDeliveryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports